/**
 * Estimate years - used to add asterics to a year.
 * @type number[]
 */
export const ESTIMATE_YEARS = [2022, 2023, 2024, 2025];

/**
 * Year of data available
 * @type number[]
 */
export const YEARS = [2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];

/**
 * Last not predicted year for a growth statistic
 */
export const GROWTH_YEAR = 2025;

/**
 * Last active year
 * Used mainly in a city view.
 */
export const ACTIVE_YEAR = 2025;

/**
 * Limits amount of countries in a list.
 */
export const MAX_COUTRY_LIST_ITEMS = 31;
